import script from "./Front.vue?vue&type=script&setup=true&lang=js"
export * from "./Front.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__